import React, { useState } from 'react';
// 1. Importer ce qui est nécessaire pour la protection
import { Outlet, Navigate } from 'react-router-dom'; 
import useAuth from '../../hooks/useAuth'; // Assurez-vous que le chemin est correct

// Vos imports existants
import Navbar from './Navbar';
import Footer from './Footer';
import './Layout.css'; 

const Layout = () => {
    // 2. Récupérer l'état d'authentification
    const { isAuthenticated } = useAuth();
    const [isNavbarVisible, setIsNavbarVisible] = useState(true);

    // 3. Ajouter la logique de protection
    if (!isAuthenticated) {
        // Si l'utilisateur n'est pas connecté, le rediriger vers la page de login
        return <Navigate to="/login" replace />;
    }

    // 4. Si l'utilisateur EST connecté, afficher le layout normal
    return (
        <div className="app-layout">
            {/* 1. On affiche la Navbar SEULEMENT si isNavbarVisible est true */}
            {isNavbarVisible && <Navbar />}
            
            <main className="main-content">
                {/* 2. On passe la fonction setIsNavbarVisible aux enfants (ProcessPage) */}
                <Outlet context={{ setIsNavbarVisible }} /> 
            </main>
            
            {/* 3. En général, si on cache la navbar (mode plein écran), on veut aussi cacher le footer */}
            {isNavbarVisible && <Footer />}
        </div>
    );
};

export default Layout;